import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    IdBankAccount: { label: i18n.t('app.id'), value: '' },
    IBANAccountNumber: { label: i18n.t('invoices.invoices_issuing.iban'), value: '' },
    BankAccountAlias: { label: i18n.t('invoices.invoices_issuing.nombre_cuenta'), value: '' },
    BIC: { label: i18n.t('invoices.invoices_issuing.bic_swift'), value: '' },
    DomiciliationDate: { label: i18n.t('agenda.domiciliation_date'), value: '', type: 'date' },
    MandateID: { label: i18n.t('agenda.mandate_id'), value: '', type: '' },
    DefaultBankAccount: { label: i18n.t('agenda.default_bank_account'), value: '', type: '' },
  } 
}
const getColumns = function getColumns () {
  return [
    { field: 'IdBankAccount', width: '100px', title: i18n.t('app.id'), hidden: true, columnMenu: 'myTemplate', locked: false },
    { field: 'BankAccountAlias', width: '185px', title: i18n.t('invoices.invoices_issuing.nombre_cuenta'), columnMenu: 'myTemplate', locked: false },
    { field: 'IBANAccountNumber', width: '300px', title: i18n.t('invoices.invoices_issuing.iban'), columnMenu: 'myTemplate', locked: false },
    
    // Se ocultan datos de contacto (TEMPORAL? - 06/06/2025) 
    // { field: 'Address.Address', width: '200px', title: i18n.t('address.location'), columnMenu: 'myTemplate', locked: false },
    // { field: 'Address.PostCode', width: '160px', title: i18n.t('address.codigo_postal'), columnMenu: 'myTemplate', locked: false },
    // { field: 'Address.Town', width: '130px', title: i18n.t('address.poblacion'), columnMenu: 'myTemplate', locked: false },
    // { field: 'Address.Province', width: '120px', title: i18n.t('address.provincia'), columnMenu: 'myTemplate', locked: false },
    // { field: 'Address.CountryCode', width: '100px', title: i18n.t('address.pais'), format: 'PAISES', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false },
    
    { field: 'BIC', width: '140px', title: i18n.t('invoices.invoices_issuing.bic_swift'), columnMenu: 'myTemplate', locked: false },
    { field: 'MandateID', width: '200px', title: i18n.t('agenda.mandate_id'), columnMenu: 'myTemplate', locked: false },
    { field: 'DomiciliationDate', width: '220px', title: i18n.t('agenda.domiciliation_date'), format: 'numeric_date', cell: 'fechaTemplate', columnMenu: 'myTemplate', locked: false },
    { field: 'DefaultBankAccount', title: i18n.t('agenda.default_bank_account'), columnMenu: 'myTemplate', cell: 'checkboxTemplate', type: 'boolean', groupable: false, locked: false, width: '200px' },
    { 
      field: 'IdSociedad', 
      title: i18n.t('companies.id_sociedad'), 
      hidden: true, 
      columnMenu: 'myTemplate', 
      width: '150px', 
      locked: false,
      only: {
        roles: [7, 8, 3],
      },
    },
    { 
      field: 'IdSede', 
      title: i18n.t('companies.id_sede'), 
      hidden: true, 
      columnMenu: 'myTemplate', 
      width: '150px', 
      locked: false,
      only: {
        roles: [7, 8, 3],
      },
    },
  ] 
}
const mystore = parent({ selectable: true, navigate: true, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
